export const focus = {
  focus: {
    ringShadow: '0 0 0 .2rem var(--p-primary-200)',
    ringWidth: '0',
  },
};
